import SamplesUnavailableButton from "./SamplesUnavailableButton";

export const FabricItem = ({
    sampleInCart,
    collectionName,
    collectionUrl,
    displayPrice,
    fabricUrl,
    fullName,
    id,
    imagePath,
    inWishlist,
    fabricInCart,
    mode,
    onRemove,
    orderSample,
    samplesUnavailable,
    supplierId,
    supplySamples,
    toggleAddedToWishlist
}) => {
    return (
        <div className="mb-32 sm-mb-36" key={id}>
            <div className="row gap-24 sm-gap-16">
                <div className="col-auto">
                    <img
                        src={imagePath}
                        className="w-h-164 sm-mb-12"
                        alt={fullName}
                    />
                </div>

                <div className="col flex-column min-height-164 sm-min-height-auto">
                    <div className="row mb-8">
                        <div className="col">
                            <div className="subtitle1 default-text">
                                {fullName}
                            </div>
                        </div>

                        <div className="col-auto m-1">
                            {
                                mode === 'recently view' &&
                                toggleAddedToWishlist &&
                                <span className={`row curtains-icon curtains-icon-Property-1Off size-24 pointer add-to-wishlist mb-2 ${inWishlist ? "active" : ""}`} onClick={() => toggleAddedToWishlist(id)}></span>
                            }
                            <span
                                className="curtains-icon curtains-icon-octicon_trash-24 size-24 gray pointer sm-ms-12"
                                onClick={() => {
                                    if (mode === 'wishlist'
                                        ? confirm("Are you sure you want to remove this item from your wishlist?")
                                        : confirm('Are you sure you want to remove this item from your recently viewed fabrics?')) {
                                        onRemove(id);
                                    }
                                }}
                            />
                        </div>
                    </div>

                    <div className="body-text3">
                        <div className="mb_5 sm-text-14 sm-mb-8">
                            <span className="gray">Collection:</span>{" "}
                            <a href={collectionUrl} className="underline">
                                {collectionName}
                            </a>
                        </div>

                        <div className="mb-20 sm-mb-12 sm-text-15">
                            £{displayPrice}{" "}
                            <span className="gray">(per metre)</span>
                        </div>
                    </div>

                    <div className='sm-no'>
                        <div className="body-text3 color-bg2 to-bottom d-flex gap-2">
                            <div className="width-145">
                                <a href={fabricUrl}>
                                    <button className="d-flex btn justify-content-center align-items-center btn-100 btn-primary gap-2 btn-primary-dark" type="button">
                                        <span className="icon-container">
                                            <svg className="btn-star-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M6.5 13L5.90225 11.3846C5.16734 9.39854 3.60146 7.83266 1.6154 7.09775L5.68248e-07 6.5L1.6154 5.90225C3.60146 5.16734 5.16734 3.60146 5.90225 1.6154L6.5 -5.68248e-07L7.09775 1.6154C7.83266 3.60146 9.39854 5.16734 11.3846 5.90225L13 6.5L11.3846 7.09775C9.39854 7.83266 7.83266 9.39854 7.09775 11.3846L6.5 13Z"></path>
                                            </svg>

                                            <svg className="btn-star-2" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M4.5 9L4.08617 7.88164C3.57739 6.50668 2.49332 5.42261 1.11836 4.91383L3.93402e-07 4.5L1.11836 4.08617C2.49332 3.57739 3.57739 2.49332 4.08617 1.11835L4.5 -3.93402e-07L4.91383 1.11835C5.42261 2.49332 6.50668 3.57739 7.88165 4.08617L9 4.5L7.88165 4.91383C6.50668 5.42261 5.42261 6.50668 4.91383 7.88164L4.5 9Z"></path>
                                            </svg>

                                            <svg className="btn-star-3" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3.5 7L3.17813 6.13017C2.78241 5.06075 1.93925 4.21759 0.869831 3.82187L3.0598e-07 3.5L0.869831 3.17813C1.93925 2.78241 2.78241 1.93925 3.17813 0.869831L3.5 -3.0598e-07L3.82187 0.869831C4.21759 1.93925 5.06075 2.78241 6.13017 3.17813L7 3.5L6.13017 3.82187C5.06075 4.21759 4.21759 5.06075 3.82187 6.13017L3.5 7Z"></path>
                                            </svg>
                                        </span>
                                        <span>View</span>
                                    </button>
                                </a>
                            </div>
                            <div className="width-200">
                                {
                                    supplySamples === false ?
                                        <SamplesUnavailableButton supplierId={supplierId} />
                                        :
                                        <button type='button' className={`col d-flex btn justify-content-center align-items-center btn-secondary gap-2 btn-primary-dark ${(sampleInCart || samplesUnavailable) ? 'disabled' : ''}`} onClick={!samplesUnavailable ? async () => await orderSample(id) : undefined} disabled={fabricInCart || samplesUnavailable}>
                                            <span order-sample-id={id}>{samplesUnavailable ? 'SAMPLES UNAVAILABLE' : sampleInCart ? 'Added to Bag' : 'order sample'}</span>
                                        </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="sm-yes">
                <div className="d-flex sm-gap-12">
                    <a className={supplySamples ? 'col' : 'col col-12'} href={fabricUrl}>
                        <button className="d-flex btn justify-content-center align-items-center btn-100 btn-primary gap-2 btn-primary-dark w-100 sm-ptb-12" type="button">
                            <span className="icon-container">
                                <svg className="btn-star-1" width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6.5 13L5.90225 11.3846C5.16734 9.39854 3.60146 7.83266 1.6154 7.09775L5.68248e-07 6.5L1.6154 5.90225C3.60146 5.16734 5.16734 3.60146 5.90225 1.6154L6.5 -5.68248e-07L7.09775 1.6154C7.83266 3.60146 9.39854 5.16734 11.3846 5.90225L13 6.5L11.3846 7.09775C9.39854 7.83266 7.83266 9.39854 7.09775 11.3846L6.5 13Z"></path>
                                </svg>

                                <svg className="btn-star-2" width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.5 9L4.08617 7.88164C3.57739 6.50668 2.49332 5.42261 1.11836 4.91383L3.93402e-07 4.5L1.11836 4.08617C2.49332 3.57739 3.57739 2.49332 4.08617 1.11835L4.5 -3.93402e-07L4.91383 1.11835C5.42261 2.49332 6.50668 3.57739 7.88165 4.08617L9 4.5L7.88165 4.91383C6.50668 5.42261 5.42261 6.50668 4.91383 7.88164L4.5 9Z"></path>
                                </svg>

                                <svg className="btn-star-3" width="7" height="7" viewBox="0 0 7 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.5 7L3.17813 6.13017C2.78241 5.06075 1.93925 4.21759 0.869831 3.82187L3.0598e-07 3.5L0.869831 3.17813C1.93925 2.78241 2.78241 1.93925 3.17813 0.869831L3.5 -3.0598e-07L3.82187 0.869831C4.21759 1.93925 5.06075 2.78241 6.13017 3.17813L7 3.5L6.13017 3.82187C5.06075 4.21759 4.21759 5.06075 3.82187 6.13017L3.5 7Z"></path>
                                </svg>
                            </span>
                            <span>View</span>
                        </button>
                    </a>
                    {
                        supplySamples &&
                        <button type='button' className={`col-6 btn justify-content-center align-items-center btn-secondary btn-primary-dark sm-ptb-12 sm-px-8 ${(sampleInCart || samplesUnavailable) ? 'disabled' : ''}`} onClick={!samplesUnavailable ? async () => await orderSample(id) : undefined} disabled={fabricInCart || samplesUnavailable}>
                            <span>{samplesUnavailable ? 'SAMPLES UNAVAILABLE' : sampleInCart ? 'Added to Bag' : 'order sample'}</span>
                        </button>
                    }
                </div>
            </div>
        </div>
    )
}